import React, { useState, useEffect } from 'react';
import {
    Table, Button, Space, Input, Form, message, Typography, Tag,
    Modal, InputNumber, Empty, Divider, Popconfirm, Tooltip
} from 'antd';
import {
    PlusOutlined, SearchOutlined,
    ExclamationCircleOutlined, GlobalOutlined
} from '@ant-design/icons';

const { Text } = Typography;

// ============================================================
// Mock 数据 — TODO: 联调时替换为接口
// ============================================================
const INIT_EVENTS = [
    { id: 1, eventId: 100000, eventName: '移动检测', descr: '检测到物体移动时触发', pushText: '检测到移动物体，请查看' },
    { id: 2, eventId: 100001, eventName: '人形识别', descr: '检测到人形时触发', pushText: '画面中有人出现，请查看' },
    { id: 3, eventId: 100002, eventName: '人脸识别', descr: '识别到已注册人脸时触发', pushText: '识别到家庭成员' },
    { id: 4, eventId: 100005, eventName: 'PIR人体侦测', descr: 'PIR传感器检测到人体时触发', pushText: '检测到有人活动' },
    { id: 5, eventId: 100015, eventName: '人脸检测', descr: '画面中出现人脸时触发', pushText: '画面中出现人脸' },
    { id: 6, eventId: 100017, eventName: '门铃呼叫', descr: '设备门铃被按下时触发', pushText: '有人按门铃，请查看' },
    { id: 7, eventId: 100400, eventName: '声音检测', descr: '检测到异常声音时触发', pushText: '检测到异常声音' },
    { id: 8, eventId: 101201, eventName: '低电检测', descr: '设备电量低于阈值时触发', pushText: '设备电量不足，请及时充电' },
    { id: 9, eventId: 102400, eventName: '跌倒检测', descr: '检测到人员跌倒时触发', pushText: '检测到有人跌倒，请立即查看' },
    { id: 10, eventId: 102500, eventName: '火焰检测', descr: '检测到火焰时触发', pushText: '检测到火焰，请注意安全' },
    { id: 11, eventId: 102600, eventName: '烟雾检测', descr: '检测到烟雾时触发', pushText: '检测到烟雾，请检查' },
    { id: 12, eventId: 102800, eventName: '哭声检测', descr: '检测到婴儿哭声时触发', pushText: '检测到宝宝哭声，请查看' },
    { id: 13, eventId: 102900, eventName: '宠物检测', descr: '检测到宠物时触发', pushText: '检测到宠物活动' },
    { id: 14, eventId: 103700, eventName: '一键呼叫-语音', descr: '设备发起语音呼叫', pushText: '有人通过设备呼叫您' },
    { id: 15, eventId: 106900, eventName: '儿童靠近危险区', descr: '儿童靠近危险区域', pushText: '儿童靠近危险区域，请注意' },
    { id: 16, eventId: 107900, eventName: '区域闯入', descr: '物体进入禁止区域', pushText: '检测到区域闯入' },
    { id: 17, eventId: 108200, eventName: '烟火侦测', descr: '检测到烟火时触发', pushText: '检测到烟火，请立即处理' },
    { id: 18, eventId: 108300, eventName: '车辆侦测', descr: '检测到车辆时触发', pushText: '检测到车辆活动' },
    { id: 19, eventId: 109300, eventName: '设备离线', descr: '设备断开连接', pushText: '设备已离线，请检查网络' },
    { id: 20, eventId: 109600, eventName: '智能告警-儿童检测', descr: '综合儿童检测告警', pushText: '儿童活动异常告警' },
    { id: 21, eventId: 110600, eventName: '宠物异常行为', descr: '宠物异常行为告警', pushText: '宠物出现异常行为' },
    { id: 22, eventId: 300000, eventName: '定时抓拍', descr: '按设定时间间隔抓拍', pushText: '定时抓拍完成' },
    { id: 23, eventId: 300001, eventName: '手动抓拍', descr: '用户手动触发抓拍', pushText: '手动抓拍成功' },
];

// ============================================================
// 主组件
// ============================================================
const EventLibrary = () => {
    // ---- 列表 ----
    const [events, setEvents] = useState(INIT_EVENTS);
    const [loading, setLoading] = useState(false);
    const [searchForm, setSearchForm] = useState({ keyword: '' });
    const [pagin, setPagin] = useState({ page: 1, pageSize: 20, total: 0 });

    // ---- Dialog ----
    const [dlgVisible, setDlgVisible] = useState(false);
    const [dlgMode, setDlgMode] = useState('add');
    const [dlgData, setDlgData] = useState(null);
    const [dlgLoading, setDlgLoading] = useState(false);
    const [eventForm] = Form.useForm();

    // ============================================================
    // 列表加载
    // ============================================================
    const loadList = async (page = 1, pageSize = 20) => {
        setLoading(true);
        await new Promise(r => setTimeout(r, 200));
        let filtered = events;
        if (searchForm.keyword) {
            const kw = searchForm.keyword.toLowerCase();
            filtered = filtered.filter(e =>
                String(e.eventId).includes(kw) || (e.eventName || '').toLowerCase().includes(kw)
            );
        }
        setPagin({ page, pageSize, total: filtered.length });
        setLoading(false);
    };

    useEffect(() => { loadList(); }, []); // eslint-disable-line

    const getPageData = () => {
        const start = (pagin.page - 1) * pagin.pageSize;
        return events
            .filter(e => {
                if (searchForm.keyword) {
                    const kw = searchForm.keyword.toLowerCase();
                    if (!String(e.eventId).includes(kw) && !(e.eventName || '').toLowerCase().includes(kw)) return false;
                }
                return true;
            })
            .slice(start, start + pagin.pageSize);
    };

    const handleSearch = () => { setPagin(p => ({ ...p, page: 1 })); loadList(1, pagin.pageSize); };
    const handleReset = () => { setSearchForm({ keyword: '' }); setPagin(p => ({ ...p, page: 1 })); };

    // ============================================================
    // CRUD
    // ============================================================
    const handleAdd = () => {
        setDlgMode('add');
        setDlgData(null);
        eventForm.resetFields();
        setDlgVisible(true);
    };

    const handleEdit = (row) => {
        setDlgMode('edit');
        setDlgData(row);
        setDlgLoading(true);
        setTimeout(() => {
            eventForm.setFieldsValue({
                eventId: row.eventId,
                eventName: row.eventName,
                pushText: row.pushText || '',
                descr: row.descr || '',
            });
            setDlgLoading(false);
        }, 150);
        setDlgVisible(true);
    };

    const handleSubmit = async () => {
        try {
            const values = await eventForm.validateFields();
            setDlgLoading(true);
            await new Promise(r => setTimeout(r, 300));
            if (dlgMode === 'add') {
                const newEvent = {
                    id: Math.max(...events.map(e => e.id), 0) + 1,
                    eventId: values.eventId,
                    eventName: values.eventName,
                    descr: values.descr || '',
                    pushText: values.pushText || '',
                };
                setEvents(prev => [...prev, newEvent]);
                message.success('创建成功');
            } else {
                setEvents(prev => prev.map(e =>
                    e.id === dlgData.id
                        ? { ...e, eventName: values.eventName, pushText: values.pushText || '', descr: values.descr || '' }
                        : e
                ));
                message.success('保存成功');
            }
            setDlgVisible(false);
            loadList(pagin.page, pagin.pageSize);
        } catch { /* 校验失败 */ } finally {
            setDlgLoading(false);
        }
    };

    const handleDelete = (row) => {
        setEvents(prev => prev.filter(e => e.id !== row.id));
        message.success('已删除');
    };

    // ============================================================
    // 表格
    // ============================================================
    const tableData = getPageData();
    const isEmpty = !loading && tableData.length === 0;
    const hasKeyword = !!searchForm.keyword;

    const columns = [
        {
            title: '事件ID', dataIndex: 'eventId', width: 110,
            render: t => <Tag color="processing" style={{ fontFamily: 'Menlo,Monaco,monospace', fontWeight: 500 }}>{t}</Tag>,
        },
        {
            title: '事件名称', dataIndex: 'eventName', width: 160,
            render: t => <Text strong style={{ color: '#303133' }}>{t || '—'}</Text>,
        },
        {
            title: '描述', dataIndex: 'descr', width: 200, ellipsis: { showTitle: false },
            render: t => <Text type="secondary" style={{ fontSize: 13 }}>{t || '—'}</Text>,
        },
        {
            title: '推送文案', dataIndex: 'pushText', width: 240, ellipsis: { showTitle: false },
            render: t => <Text type="secondary" style={{ fontSize: 13 }}>{t || '—'}</Text>,
        },
        {
            title: '操作', width: 130, align: 'center',
            render: (_, record) => (
                <Space size={0} split={<Divider type="vertical" />}>
                    <Button type="link" size="small" onClick={() => handleEdit(record)}>编辑</Button>
                    <Popconfirm
                        title="删除确认"
                        description={`确认删除事件「${record.eventName || record.eventId}」？`}
                        icon={<ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />}
                        onConfirm={() => handleDelete(record)}
                        okText="确认删除"
                        okButtonProps={{ danger: true }}
                        cancelText="取消"
                    >
                        <Button type="link" size="small" danger>删除</Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    // ============================================================
    // 渲染
    // ============================================================
    return (
        <div style={{ padding: '20px 20px 0', background: '#fff', minHeight: '100%' }}>
            {/* ---- 搜索栏 ---- */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                <Space size={10}>
                    <Input
                        prefix={<SearchOutlined />}
                        placeholder="搜索 EventID / 名称"
                        value={searchForm.keyword}
                        onChange={e => setSearchForm(p => ({ ...p, keyword: e.target.value }))}
                        onPressEnter={handleSearch}
                        style={{ width: 240 }}
                        allowClear
                    />
                    <Button type="primary" onClick={handleSearch}>查询</Button>
                    <Button onClick={handleReset}>重置</Button>
                </Space>
                <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>添加事件</Button>
            </div>

            {/* ---- 表格 ---- */}
            {!isEmpty && (
                <Table
                    columns={columns}
                    dataSource={tableData}
                    rowKey="id"
                    loading={loading}
                    size="small"
                    pagination={{
                        current: pagin.page,
                        pageSize: pagin.pageSize,
                        total: pagin.total,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50'],
                        showTotal: t => `共 ${t} 条`,
                        onChange: (p, ps) => { setPagin(prev => ({ ...prev, page: p, pageSize: ps })); },
                    }}
                />
            )}

            {/* ---- 空状态 ---- */}
            {isEmpty && (
                <Empty
                    description={hasKeyword ? '未找到匹配的事件' : '暂无事件数据'}
                    style={{ padding: '60px 0' }}
                >
                    {!hasKeyword && <Button type="primary" onClick={handleAdd}>添加事件</Button>}
                </Empty>
            )}

            {/* ═══════════════════════════════════════ */}
            {/* 事件 Dialog（对齐 Real EventDialog） */}
            {/* ═══════════════════════════════════════ */}
            <Modal
                title={dlgMode === 'add' ? '添加事件' : '编辑事件'}
                open={dlgVisible}
                onOk={handleSubmit}
                onCancel={() => setDlgVisible(false)}
                confirmLoading={dlgLoading}
                okText={dlgMode === 'add' ? '确认创建' : '确认保存'}
                cancelText="取消"
                width={560}
                destroyOnClose
                maskClosable={false}
            >
                <Form form={eventForm} layout="horizontal" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <Form.Item
                        name="eventId" label="EventID"
                        rules={[{ required: true, message: '请输入 EventID' }]}
                    >
                        <InputNumber
                            min={1} max={99999999}
                            disabled={dlgMode === 'edit'}
                            placeholder="请输入 EventID"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="eventName" label="事件名称"
                        rules={[{ required: true, message: '请输入事件名称' }]}
                    >
                        <Space.Compact style={{ width: '100%' }}>
                            <Input placeholder="请输入事件名称" style={{ flex: 1 }} />
                            <Tooltip title="多语言配置">
                                <Button icon={<GlobalOutlined />} />
                            </Tooltip>
                        </Space.Compact>
                    </Form.Item>

                    <Form.Item
                        name="pushText" label="推送文案"
                        rules={[{ required: true, message: '请输入推送文案' }]}
                    >
                        <Space.Compact style={{ width: '100%' }}>
                            <Input placeholder="请输入推送文案" style={{ flex: 1 }} />
                            <Tooltip title="多语言配置">
                                <Button icon={<GlobalOutlined />} />
                            </Tooltip>
                        </Space.Compact>
                    </Form.Item>

                    <Form.Item name="descr" label="描述">
                        <Input.TextArea rows={3} maxLength={512} showCount placeholder="请输入描述" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default EventLibrary;
